﻿import Tab from './components/tabs/tab.vue';
import Tabs from './components/tabs/tabs.vue';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';

const tabsApp = {
    components: {
        Tab,
        Tabs
    },
    mounted() {
        bulmaCollapsible.attach('.is-collapsible');
    }
};

export default tabsApp;